import ShareAuth from '@link/share/vendors/firebase';
import { auth } from '@link/shop/stores';

const shopAuth = new ShareAuth(auth);

export default shopAuth;
